import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SupportChat } from "@/components/site/SupportChat";
import { RefundFlow } from "@/components/site/RefundFlow";

export default function Support() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative bg-[#0A0A0C] text-white min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="border-b border-white/10 bg-black/50 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link data-testid="support-back" to="/" className="flex items-center gap-2 label-caps text-white/60 hover:text-white transition-colors duration-300">
            <ArrowLeft size={16} /> Back to home
          </Link>
          <span className="flex items-center gap-2">
            <span className="font-future text-sm">PivoT</span>
            <span className="font-origin italic text-white/60">ransition</span>
          </span>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16 lg:py-24">
        <p className="label-caps text-[var(--neon-cyan)] mb-5">Help centre</p>
        <h1 className="font-future text-4xl sm:text-5xl tracking-tight glow-text">How can we help?</h1>
        <p className="mt-5 text-white/60 max-w-2xl leading-relaxed">
          Chat with Aria for quick answers on products, pricing, downloads and promo codes — or start a
          return below if something isn&apos;t right.
        </p>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          <div className="lg:col-span-3">
            <SupportChat />
          </div>
          <div className="lg:col-span-2">
            <RefundFlow />
          </div>
        </div>
      </div>
    </div>
  );
}
